import { useCallback } from 'react';

import { useGetDateRangeFormatted } from '@/hooks/useGetDateRangeFormatted';
import { FormatScheduleItemType, FormattedScheduleDates } from '@/types/schedules';
import { getScheduleFormatted } from '@/utils/date';

type GetScheduleFormattedDatesParams = {
  startDatetime: string;
  endDatetime: string | null;
  schedule: FormatScheduleItemType[];
};

export function useGetScheduleFormattedDates() {
  const getDateRangeFormatted = useGetDateRangeFormatted();

  const getScheduleFormattedDates = useCallback(
    ({
      startDatetime,
      endDatetime,
      schedule,
    }: GetScheduleFormattedDatesParams): FormattedScheduleDates => {
      const dateRange = getDateRangeFormatted(startDatetime, endDatetime);
      const schedules = getScheduleFormatted(schedule);

      return {
        dateRange,
        schedules,
      };
    },
    [getDateRangeFormatted]
  );

  return getScheduleFormattedDates;
}
